import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../services/api';

// Async thunks for API calls
export const fetchInstructors = createAsyncThunk('instructors/fetchInstructors', async (classType = null) => {
  try {
    const response = await api.getInstructors(classType);
    return response.data;
  } catch (error) {
    console.error('Error fetching instructors:', error);
    return [];
  }
});

export const createInstructor = createAsyncThunk('instructors/createInstructor', async (instructorData) => {
  const response = await api.createInstructor(instructorData);
  return response.data;
});

export const updateInstructor = createAsyncThunk('instructors/updateInstructor', async ({ id, data }) => {
  const response = await api.updateInstructor(id, data);
  return response.data;
});

export const deleteInstructor = createAsyncThunk('instructors/deleteInstructor', async (id) => {
  await api.deleteInstructor(id);
  return id;
});

const instructorsSlice = createSlice({
  name: 'instructors',
  initialState: {
    instructors: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInstructors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInstructors.fulfilled, (state, action) => {
        state.loading = false;
        state.instructors = action.payload;
      })
      .addCase(fetchInstructors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createInstructor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createInstructor.fulfilled, (state, action) => {
        state.loading = false;
        state.instructors.push({
          ...action.payload,
          id: action.payload._id || action.payload.id,
        });
      })
      .addCase(createInstructor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(updateInstructor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateInstructor.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.instructors.findIndex(
          (i) => i.id === action.payload._id || i.id === action.payload.id || i._id === action.payload._id
        );
        if (index !== -1) {
          state.instructors[index] = {
            ...action.payload,
            id: action.payload._id || action.payload.id,
          };
        }
      })
      .addCase(updateInstructor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteInstructor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteInstructor.fulfilled, (state, action) => {
        state.loading = false;
        state.instructors = state.instructors.filter(
          (i) => i.id !== action.payload && i._id !== action.payload
        );
      })
      .addCase(deleteInstructor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearError } = instructorsSlice.actions;
export default instructorsSlice.reducer;
